import { Stack, Typography } from '@mui/material';
import { COLOR_BG_SECONDARY, TokenFormat } from 'shared';

interface InsufficientFundsWarningProps {
  depositedAmount: string | number;
  cost: string | undefined;
  symbol: string;
  decimals: number;
}

export const InsufficientFundsWarning = ({
  depositedAmount,
  cost,
  symbol,
  decimals,
}: InsufficientFundsWarningProps) => {
  return (
    <Stack borderRadius={3} bgcolor={COLOR_BG_SECONDARY} justifyContent="center" p={1.5}>
      <Typography variant="body2" className="secondary">
        Deposited balance:{' '}
        <TokenFormat
          amount={depositedAmount.toString()}
          maxDecimalDigits={decimals}
          maxTotalLength={18}
          trimEllipsis
          decimals={decimals}
          symbol={symbol}
          className="primary"
        />
      </Typography>
      <Typography variant="body2" className="secondary">
        Cost:{' '}
        <TokenFormat
          amount={cost}
          maxDecimalDigits={decimals}
          maxTotalLength={18}
          trimEllipsis
          decimals={decimals}
          symbol={symbol}
          className="primary"
        />
      </Typography>
      <Typography variant="body2" className="accent">
        Please send the remaining amount to finish the purchase.
      </Typography>
    </Stack>
  );
};
